export const programming = [
  {
    id: 'true',
    label: 'Programado',
  },
  {
    id: 'false',
    label: 'Não programado',
  },
];

export const getProgramming = (code?: string | null) =>
  programming.find((s) => s.id.toUpperCase() === code?.toUpperCase());
